import React from 'react'
import Header from './Header'
import Footer from './Footer'

type LayoutProps = {
  children: React.ReactNode
}

/**
 * Sidebar is position:fixed (full height).
 * Top utility bar + page content live in .ex-main so header never covers the sidebar logo.
 * Mobile uses the hamburger + slide-out sidebar only (no bottom dock — avoids double nav).
 */
const Layout = (props: LayoutProps) => {
  const { children } = props

  return (
    <div id="workspace-layout-root" className="ex-workspace">
      <div className="ex-workspace-glow" aria-hidden="true">
        <div className="glow-tr" />
        <div className="glow-bl" />
      </div>

      <main id="workspace-main-content" className="ex-main">
        {/* Sidebar (fixed) + sticky content topbar */}
        <Header onChangeMenu={() => {}} />

        <div id="content-container-padding" className="ex-main-inner">
          <div id="active-tab-wrapper" className="ex-main-content">
            {children}
          </div>
          <Footer />
        </div>
      </main>
    </div>
  )
}

export default Layout
